
  var _styles = {
  "experience-card-wrapper": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "width": "8.24rem",
    "height": "3.77333rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "marginRight": "0.16rem"
  },
  "experience-card-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "8.24rem",
    "height": "3.77333rem"
  },
  "experience-card": {
    "display": "flex",
    "flexDirection": "row",
    "width": "8.24rem",
    "height": "3.77333rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "experience-card__cover": {
    "display": "flex",
    "flexDirection": "column",
    "width": "2.82667rem",
    "height": "3.77333rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "experience-card__cover-image": {
    "position": "relative",
    "width": "2.82667rem",
    "height": "3.77333rem"
  },
  "experience-card__gradient": {
    "display": "flex",
    "flexDirection": "column",
    "position": "absolute",
    "left": 0,
    "bottom": 0,
    "width": "7.2rem",
    "height": "2.66667rem",
    "justifyContent": "flex-end",
    "paddingLeft": "0.32rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.32rem"
  },
  "experience-card__info-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "position": "absolute",
    "width": "100%",
    "height": "1.62667rem",
    "bottom": 0
  },
  "experience-card__info": {
    "display": "flex",
    "flexDirection": "column",
    "position": "absolute",
    "left": "0.16rem",
    "bottom": "0.16rem",
    "width": "100%"
  },
  "experience-card__title": {
    "maxWidth": "100%",
    "fontSize": "0.37333rem",
    "lineHeight": "0.48rem",
    "fontWeight": "600",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "marginBottom": "0.04rem"
  },
  "experience-card__driving-tag": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.05333rem",
    "alignSelf": "flex-start"
  },
  "experience-card__driving-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem",
    "fontFamily": "PingFang SC",
    "color": "rgb(255,255,255)",
    "fontWeight": "400"
  },
  "experience-card__content": {
    "paddingTop": "0.32rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.32rem",
    "paddingLeft": "0.16rem"
  },
  "experience-card__highlights": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-start",
    "marginBottom": "0.21333rem"
  },
  "experience-card__tips": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-start"
  },
  "experience-card__icon": {
    "display": "flex",
    "flexDirection": "column",
    "marginRight": "0.10667rem",
    "marginTop": "0.05333rem"
  },
  "experience-card__highlights-text": {
    "width": "4.56rem",
    "height": "1.44rem",
    "lineHeight": "0.48rem",
    "fontSize": "0.32rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC"
  },
  "experience-card__tips-text": {
    "width": "4.56rem",
    "height": "1.44rem",
    "lineHeight": "0.48rem",
    "fontSize": "0.32rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC"
  },
  "experience-card__label": {
    "fontWeight": "600"
  },
  "experience-card__highlights-content": {
    "fontWeight": "400"
  }
};



  module.exports = _styles;
  